import React from 'react';
import { useSummaryStyles } from './styles';
const Summary = ({ children }) => {
    const ownClasses = useSummaryStyles();
    return React.createElement("div", { className: ownClasses.root }, children);
};
export default Summary;
